<template lang="pug">
  include /mixins
  div
    div
      group-view(
        :attributes='attributes'
        :is-travel-model='isTravelModel'
        @attrs:update='checkedAttrs = $event'
      )

      template(v-if="brandingBrands && brandingBrands.length")
        +b.P.ds-caption.--color_accent.--size_2md.--medium.tt-space_mb--2.tt-space_mt--2 {{ _("Бренд") }}
          +b.g-row.tt-space_mt--2
            +b.g-cell.g-cols--12.--6-sm.--5-mac
              d-control-multiselect(
                :allow-empty="false"
                :options="brandingBrands"
                :close-on-select="true"
                :clear-on-select="false"
                :preselect-first="true"
                :taggable="false"
                v-model="brand"
                label="brand",
                track-by='id'
              )
                template(
                  slot="singleLabel"
                  slot-scope="props"
                )
                  +b.multiselect__custom-single
                    | {{ props.option.brand }}

                template(
                  slot="option"
                  slot-scope="props"
                )
                  +b.multiselect__custom-option
                    +e.custom-single {{ props.option.brand }}

        template(v-if='brand')
          group-view(
            :attributes='brand.attributes'
            :is-travel-model='isTravelModel'
            @attrs:update='checkedBrandAttrs = $event'
          )

    slot(name='conditions')

    +b.g-row.tt-space_mb--6.tt-space_mt--6
      +b.g-cell.g-cols--12.--5-md.--7-xl.--6-mac
        +b.tt-button(
            @click.prevent='sendOffer'
          )
          +e.P.title {{ _("Отправить заявку") }}

</template>

<script>
import { getAttrsResource } from '@api/offers.service'
import RequestModal from '@app/SpecialOffers/RequestModal'

export default {
  name: 'AttributesViewController',
  props: {
    id: Number,
    isTravelModel: Boolean,
    img: String,
    date: String,
    userName: String,
    userPhone: String,
    modelName: String,
    description: String,
  },
  data() {
    return {
      attributes: [],
      formdata: {},
      mainTitle: '',
      checkedAttrs: [],
      checkedBrandAttrs: [],
      brandingBrands: [],
      brand: [],
    }
  },
  mounted() {
    this.getOfferAttrs()
  },
  methods: {
    async getOfferAttrs() {
      const {
        data: {
          props: {
            attributes,
            title,
            branding_brands,
          },
        },
      } = (await getAttrsResource.execute({ id: this.id }))
      this.attributes = attributes
      this.mainTitle = title
      this.brandingBrands = branding_brands
    },
    sendOffer() {
      const checkedAttrs = this.checkedAttrs.concat(this.checkedBrandAttrs)
      this.$modal.show(
        RequestModal,
        {
          info: {
            id: this.id,
            img: this.img,
            maintitle: this.mainTitle,
            description: this.description,
            date: this.date,
            modelName: this.modelName,
            userName: this.userName,
            userPhone: this.userPhone,
            attributes: checkedAttrs,
            brand: this.brand,
            sendAttributes: !this.isTravelModel,
          },
        }, {
          height: 'auto',
          minWidth: 300,
          maxWidth: 370,
          adaptive: true,
          scrollable: true,
        }
      )
    },
  },
}
</script>
